<template>
  <div id="app">

    <!-- <i class="icon-radio_button_checked" style="color: black; font-size: 24px; position: absolute;"></i> -->

    <router-view  />
  </div>
</template>

<script>
export default {
  data() {
    return {
      addressData: null
    };
  },
  components: {
  },
   created() {
  },
  mounted(){
    
  }

}
</script>
<style lang="scss">
@import url(@/assets/css/font-face.css);
@import url(@/assets/css/icon.css);

#app {
  // height: 1200px;
  font-family: "Lucida Grande","Helvetica","Arial","微軟正黑體修正","微軟正黑體",sans-serif;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  color: #212529;
  text-align: left;

  a {
    text-decoration: none;
  }

  .cls-1 {
    fill: #627070;
  }

  .cls-2 {
    fill: #fff;
  }

}

[v-cloak] {
  display: none !important;
}
</style>
